import { query } from "../_generated/server";
import { v } from "convex/values";

export const getUserPreferences = query({
  args: {},
  handler: async (ctx, args) => {
    const identity = await ctx.auth.getUserIdentity();
    if (!identity) return null;

    const userId = identity.subject;

    const prefs = await ctx.db
      .query("userPreferences")
      .withIndex("by_userId", (q) => q.eq("userId", userId))
      .first();

    if (!prefs) {
      // If no preferences exist, return default values
      // The webhook handler will create the actual record
      return {
        userId,
        restrictedWords: [],
        serviceTier: "free" as const,
        monthlyUsage: 0,
        monthlyLimit: 3,
        enableSectionLabeling: true,
        strikeListWords: [],
        strikeListPhrases: [],
        strikeListSimilarities: [],
        strikeListLiteraryDevices: [],
        createdAt: Date.now(),
        updatedAt: Date.now(),
      };
    }

    return prefs;
  },
});